import React, { useState } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import UserInfoPopup from "./UserInfoPopup";

export default function UserSearch() {
  const [UsersData, setUsersData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const token = localStorage.getItem("shraddhatoken");

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const value = e.target.value.trim();
    setSearchInput(value);

    if (value === "") {
      setUsersData([]);
      setEmailError(false);
      return;
    }

    if (!isValidEmail(value)) {
      setEmailError(true);
      setUsersData([]);
      return;
    } else {
      setEmailError(false);
      fetchUsersData(value);
    }
  };

  const handleRowClick = (params) => {
    setSelectedUser({
      admin_Id: params.row.id,
      admin_FirstName: params.row.name.split(" ")[0],
      admin_LastName: params.row.name.split(" ")[1] || "",
      admin_Email: params.row.email,
      admin_CmpName: params.row.CmpName,
      admin_Mobile: params.row.mobileNumber,
      member_From: params.row.member_From, 
      member_To: params.row.member_To,
    });
  };

  const handleClosePopup = () => {
    setSelectedUser(null);
  };

  const fetchUsersData = async (search) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/shraddha/operation/search",
        { searchTerm: search },
        {
          headers: { Authorization: token },
        }
        
      );
      // console.log(response.data)
      const users = response.data;
      setUsersData(users);
    } catch (error) {
      console.log("Error fetching Data! ", error);
    }
  };

  const UserList =
    UsersData && typeof UsersData === "object" && UsersData.admin_Id
      ? [
          {
            id: UsersData.admin_Id,
            name: UsersData.admin_FirstName + " " + UsersData.admin_LastName,
            email: UsersData.admin_Email,
            CmpName: UsersData.admin_CmpName,
            mobileNumber: UsersData.admin_Mobile,
            member_From: UsersData.member_From, // Include member_from in UserList
            member_To: UsersData.member_To,     // Include member_to in UserList
          },
        ]
      : [];

  const columns = [
    {
      field: "",
      headerName: "SR No",
      headerAlign: "center",
      align: "center",
      width: 80,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => params.api.getRowIndex(params.id) + 1,
    },
    {
      field: "name",
      headerName: "Name",
      headerAlign: "center",
      align: "center",
      width: 200,
    },
    {
      field: "email",
      headerName: "Email",
      headerAlign: "center",
      align: "center",
      width: 300,
    },
    {
      field: "CmpName",
      headerName: "Company Name",
      headerAlign: "center",
      align: "center",
      width: 200,
    },
    {
      field: "mobileNumber",
      headerName: "Mobile Number",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
  ];

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        paddingTop: 10,
        paddingLeft: 33,
        paddingRight: 3,
        backgroundColor: "#f4f6f7",
        borderRadius: "10px",
      }}
    >
      {selectedUser && (
        <UserInfoPopup
          user={selectedUser}
          usersData={UserList}
          onClose={handleClosePopup}
          token={token}
        />
      )}
      
      <Box
        mb={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="row"
      >
        <Typography variant="h1">Search User</Typography>
        <TextField
          label="Search"
          variant="outlined"
          size="small"
          value={searchInput}
          onChange={handleChange}
          error={emailError}
          helperText={emailError ? "Please enter a valid email address" : ""}
          sx={{
            width: "300px",
            "& .MuiInputBase-input": {
              color: "black",
            },
            "& .MuiInputLabel-root": {
              color: "black",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "black",
              },
              "&:hover fieldset": {
                borderColor: "black",
              },
              "&.Mui-focused fieldset": {
                borderColor: "black",
              },
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end" sx={{ color: "black" }}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box
        height="80vh"
        sx={{
          overflowX: "auto",
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
            color: "black",
            cursor:"pointer"
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#E9F3F5",
            borderBottom: "none",
            color: "black",
          },
          "& .MuiDataGrid-columnHeader:focus": {
            outline: "none",
            boxShadow: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            outline: "none",
            boxShadow: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: "#E9F3F5",
          },
          "& .MuiDataGrid-overlay": {
            backgroundColor: "#ffffff",
            color: "gray",
          },
        }}
      >
        <DataGrid
          rows={UserList}
          columns={columns}
          onRowClick={handleRowClick}
          rowHeight={35}   // reduce row height (default ~52)
          headerHeight={40} // reduce header height
        />
      </Box>
    </Box>
  );
}